/**
 * Insere um número 0 antes do dígito principal para todo e qualquer número inteiro com 1 dígito.
 * @param {number} number O número que terá o 0
 * @returns {number} O número de 1 dígito com o número 0 o antecedendo
 *
 * Ex: -1 -> -01 | 0 -> 00 | 5 -> 05 | 9 -> 09
 */
export default function prependZeroToSingleDigitNumber(number: number) {
  return new Intl.NumberFormat('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  }).format(number)
}
